import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';

import { deleteResidueIntake } from '../../../../../slices/residueIntake/thunk';
import { setRequireCloseModal } from '../../../../../slices/residueIntake/reducer';

const DeleteIntakeModal = ({
	dataResidueIntake,
	isOpen,
	handlerToggleModal,
}) => {
	const dispatch = useDispatch();

	const selectorResidueIntake = createSelector(
		state => state.ResidueIntakes,
		residueIntake => ({
			isDeleting: residueIntake.isDeleting,
			requireCloseModal: residueIntake.requireCloseModal,
		})
	);
	const { isDeleting, requireCloseModal } = useSelector(selectorResidueIntake);

	useEffect(() => {
		if (isOpen && requireCloseModal) {
			dispatch(setRequireCloseModal(false));
			handlerToggleModal();
		}
	}, [requireCloseModal, isOpen, dispatch, handlerToggleModal]);

	const handleDelete = () => {
		dispatch(deleteResidueIntake(dataResidueIntake));
	};

	const residueName =
		dataResidueIntake?.residue?.name ||
		dataResidueIntake?.residue_name ||
		dataResidueIntake?.residue_id ||
		'';
	const warehouseName =
		dataResidueIntake?.warehouse?.name ||
		dataResidueIntake?.warehouse_name ||
		dataResidueIntake?.warehouse_id ||
		'';

	return (
		<Modal
			isOpen={isOpen}
			toggle={handlerToggleModal}
			size='sm'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader className='modal-title' />
			<ModalBody className='text-center p-3'>
				<lord-icon
					src='https://cdn.lordicon.com/tdrtiskw.json'
					trigger='loop'
					colors='primary:#f06548,secondary:#405189'
					style={{ width: '90px', height: '90px' }}
				></lord-icon>
				<div className='mt-2'>
					<h3 className='mb-3'>¡Estás a punto de eliminar un ingreso RESPEL!</h3>
					<p className='text-muted mb-3'>
						Esta acción emitirá un movimiento de cancelación en el ledger y
						descontará los kilogramos del stock de la bodega.
					</p>
					<p className='small mb-1'>
						<strong>Residuo:</strong> {residueName || '-'}
					</p>
					<p className='small mb-3'>
						<strong>Bodega:</strong> {warehouseName || '-'}
					</p>
					<div className='hstack gap-2 justify-content-center'>
						<Button
							className='btn-danger btn-label'
							onClick={handlerToggleModal}
						>
							<i className='icon-x label-icon'></i> Cancelar
						</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={handleDelete}
							disabled={isDeleting}
						>
							{isDeleting ? (
								<i className='label-icon'>
									<Spinner size='sm' />
								</i>
							) : (
								<i className='icon-check-check label-icon'></i>
							)}{' '}
							Confirmar
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default DeleteIntakeModal;
